import { useState, useEffect, useContext, useRef } from 'react';

import { PracticeReseveContext } from './PracticeReseveContext';
import PracticeReserveBeforeLesson from './beforeLesson/PracticeReserveBeforeLesson';
import PracticeReserveForm from './form/PracticeReserveForm';
import Loading from '../../common/loading/Loading';

import {
  requestApi,
  formatDate, formatTime,
} from '../../../util/utility';

import { PracticeReserveSituationDisplaySituations } from '../../../models/practice/reserve/situation/PracticeReserveSituation';
import { PracticeReserveInstructorModel } from '../../../models/practice/reserve/instructor/PracticeReserveInstructor';


function PracticeReserve() {
  // パラメータ(初回データ)
  const params = new URLSearchParams(window.location.search);
  const dateNow = params.get('date_now') || '';
  const dfInstId = params.get('inst_id') || '';
  const lessonTermMinute = 15;
  const [user, setUser] = useState<any>(null);
  const [config, setConfig] = useState(null);
  const [displaySituations, setDisplaySituations] = useState<PracticeReserveSituationDisplaySituations>([]);
  const [vars, setVars] = useState(null);
  const formRef = useRef<HTMLFormElement>(null);
  // 入力値
  const [instId, setInstId] = useState<string|null>(dfInstId);
  const [lsnMin, setLsnMin] = useState<number>(lessonTermMinute);
  const [isTrial, setIsTrial] = useState<boolean>(true);
  const [selectedScheduleId, setSelectedScheduleId] = useState<string|null>(null);
  const [selectedSituation, setSelectedSituation] = useState<string|null>(null);
  const [requestContent, setRequestContent] = useState<string>('');
  // 出力値
  const [title, setTitle] = useState<string>('');
  const [instructors, setInstructors] = useState<PracticeReserveInstructorModel[]>([]);
  const [instProfile, setInstProfile] = useState(null);
  const [calendar, setCalendar] = useState([]);
  const [chkCal, setChkCal] = useState({});

  const [isLesson, setIsLesson] = useState<boolean>(true);
  const [trialCount, setTrialCount] = useState<number | null>(null);
  const [isTicketLess, setIsTicketLess] = useState<boolean>(false);
  const [lessTicketCount, setLessTicketCount] = useState<number>(0);

  // キッズプラクティス
  const [kidPracticeInstIds, setKidPracticeInstIds] = useState<[]>([]);

  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  // サーバアクセス
  useEffect(() => {
    let cancelled = false;

    (async () => {
      setIsLoading(true);
      try {
        // API実行
        const resp = await requestApi({
          inc: '/backend/api/functions/user/practice',
          date_now: dateNow,
          inst_id: instId,
          lesson_minutes: lsnMin,
        });
        if (cancelled) return;

        // 取得データの格納
        setDisplaySituations(resp.displaySituations);
        setConfig(resp.config);
        setTitle(resp.title);
        setVars(resp.vars);
        setUser(resp.user);
        setInstructors(resp.instructor);
        setInstProfile(resp.instProfile);
        setIsLesson(resp.isLesson);
        setCalendar(resp.calendar);
        setChkCal(resp.chkCal);
        setIsTicketLess(resp.isTicketLess);
        setLessTicketCount(resp.lessTicketCount);
        setKidPracticeInstIds(resp.kidPracticeInstIds || []);
        // 初期化
        setSelectedScheduleId(null);
      } catch(err) {
        if (err instanceof Error) {
          console.warn(err.message);
        }
      } finally {
        setIsFirstLoad(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 100)
      }
    })();

    // cleanup関数でキャンセルフラグを立てる
    return () => {
      cancelled = true;
    };
  }, [instId, lsnMin])


  // 無料回数
  useEffect(() => {
    if(user) {
      if(user?.register_items?.practice) {
        setTrialCount(user?.register_items?.practice);
      } else {
        setTrialCount(0);
      }
    }
  }, [user])


  const contextVal = {
    lessonTermMinute: lessonTermMinute,
    user: user,
    config: config,
    vars: vars,
    setVars: setVars,
    title: title,
    isLesson: isLesson,
    isLoading: isLoading,
    formRef: formRef,
    // 講師データ
    instId: instId,
    setInstId: setInstId,
    instructors: instructors,
    setInstructors: setInstructors,
    instProfile: instProfile,
    kidPracticeInstIds: kidPracticeInstIds,
    // 日時選択
    calendar: calendar,
    chkCal: chkCal,
    // 時間選択データ
    trialCount: trialCount,
    lsnMin: lsnMin,
    setLsnMin: setLsnMin,
    isTrial: isTrial,
    setIsTrial: setIsTrial,
    // 日時選択データ
    selectedScheduleId: selectedScheduleId,
    setSelectedScheduleId: setSelectedScheduleId,
    // シチュエーション
    displaySituations: displaySituations,
    selectedSituation: selectedSituation,
    setSelectedSituation: setSelectedSituation,
    // コメント
    requestContent: requestContent,
    setRequestContent: setRequestContent,
    // 送信
    isTicketLess: isTicketLess,
    lessTicketCount: lessTicketCount,
    // 日時フォーマット関数
    formatDate: formatDate,
    formatTime: formatTime,
  }


  return (
    <PracticeReseveContext.Provider value={contextVal}>
      {isFirstLoad ?
        <>
          <h3 id="practice_reservation" className="midashi1 bold">プラクティスを予約する</h3>
          <div style={{ margin: '0 -15px', padding: '15px', backgroundColor: '#f0f0f0' }}>
            
            {/* レッスンを開始していない */}
            <PracticeReserveBeforeLesson />

            {/* 予約フォーム */}
            <PracticeReserveForm />

          </div>
        </>
      :
        <Loading />
      }
    </PracticeReseveContext.Provider>
  );
}
  
export default PracticeReserve;